type Key = 'Enter' | 'ArrowDown' | 'ArrowUp' | 'Escape' | 'Tab' | 'Shift' | ' ';

export const handleKeyEvent = async <T>(
  event: React.KeyboardEvent<T> | KeyboardEvent,
  key: Key,
  handler: (event: React.KeyboardEvent<T> | KeyboardEvent) => void,
) => {
  if (event.key !== key) return;
  return handler(event);
};

export const handleElementKeyEvent = async <T>(
  event: React.KeyboardEvent<T>,
  key: Key | Key[],
  handler: (event: React.KeyboardEvent<T>) => void,
) => {
  if (typeof key === 'string') {
    if (event.key !== key) return;
  } else {
    if (!key.includes(event.key as Key)) return;
  }

  return handler(event);
};
